fetch('/env.json')
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    window.FETCHED_ENV_DATA = data;
  })
  .finally(() => {
    if (IS_STANDALONE) {
      import('./standalone');
    } else {
      import('./index');
    }
  });
